module.exports = [{
      plugin: require('/zeit/3646bbd7/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
